import React from 'react';
import '../../App.scss';
import { Form, Button } from 'react-bootstrap';
import UserAccessApi from '../../api/UserAccessApi';

class SignIn extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.signIn = this.signIn.bind(this);
    this.state = {
      version: '',
      errorMessage: "" // hata mesajı için
    };
  }

  async componentDidMount() {
    try {
      const version = await UserAccessApi.getAppVersion();
      this.setState({ version });
    } catch (error) {
      console.error("Versiyon alınamadı:", error);
    }
  }

  async signIn(e: any) {
    e.preventDefault();
    const userName = e.target.userName.value;
    const password = e.target.password.value;

    const requestDTO = { userName, password };

    let response = await UserAccessApi.signIn(requestDTO);

    if (response.success) {
      localStorage.setItem("x-ozsk-auth-token", response.data.authToken);
      setTimeout(() => {
        window.location.assign("/dashboard");
      }, 352);
    } else {
      localStorage.removeItem("x-ozsk-auth-token");

      // Hata mesajını state'e koy
      this.setState({
        errorMessage: response.error?.message || "Giriş başarısız. Lütfen tekrar deneyin."
      });
    }
  }

  render() {
    const { version, errorMessage } = this.state;

    return (
      <div className="login-pane centered-40-percent">
        <div className="zero-div">
          <div style={{ marginTop: "100px", marginBottom: "25px", paddingBottom: "15px", textAlign: "center" }}>
            <img width="240px" height="80px" src="https://ozisiksut.com.tr/wp-content/uploads/2021/10/weblogo1.png" />
          </div>

          <Form onSubmit={this.signIn}>
            {errorMessage && (
              <div style={{ color: "red", marginBottom: "10px", textAlign: "center" }}>
                {errorMessage}
              </div>
            )}

            <Form.Group className="mb-3" controlId="userName">
              <Form.Label>Kullanıcı Adı</Form.Label>
              <Form.Control name="userName" />
            </Form.Group>

            <Form.Group className="mb-3" controlId="password">
              <Form.Label>Şifre</Form.Label>
              <Form.Control name="password" type="password" />
            </Form.Group>

            <div className="row" style={{ paddingLeft: "12px", paddingRight: "12px", paddingTop: "10px" }}>
              <Button variant="danger" type="submit">
                Giriş Yap
              </Button>
            </div>

            {version && (
              <div
                style={{
                  textAlign: "center",
                  marginTop: "10px",
                  color: "#aaa",
                  fontSize: "13px",
                  fontWeight: 300,
                  fontFamily: "Arial, sans-serif"
                }}
              >
                v{version}
              </div>
            )}
          </Form>
        </div>
      </div>
    );
  }
}

export default SignIn;
